import { render, staticRenderFns } from "./ZhanhuiIndustryHome.vue?vue&type=template&id=0f14180a&scoped=true"
import script from "./ZhanhuiIndustryHome.vue?vue&type=script&lang=js"
export * from "./ZhanhuiIndustryHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f14180a",
  null
  
)

export default component.exports